import { render, staticRenderFns } from "./manage-related-channel-modal.vue?vue&type=template&id=d5b44510"
import script from "./manage-related-channel-modal.vue?vue&type=script&lang=js"
export * from "./manage-related-channel-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports